import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map, of } from 'rxjs';
import { OwnerScopeService } from '../service/owner-scope.service';

export const proxySettingsGuard: CanActivateFn = () => {
  const messageService = inject(MessageService);
  const translateService = inject(TranslateService);
  const ownerScopeService = inject(OwnerScopeService);

  return ownerScopeService.getOwnerScope().pipe(
    map((ownerScope) => {
      const platformOwner = ownerScope?.platformOwnerCode;
      const ownerCodes = ownerScope?.ownerCodes ?? [];
      const isProxyPartnerUser =
        ownerScope?.mode === 'PROXY' &&
        ownerCodes.length === 1 &&
        !!platformOwner &&
        ownerCodes[0] !== platformOwner;

      if (isProxyPartnerUser) {
        messageService.add({
          severity: 'error',
          sticky: true,
          summary: translateService.instant('forbidden.summary'),
          detail: translateService.instant('forbidden.detail'),
        });
      }

      return !isProxyPartnerUser;
    }),
    catchError(() => of(true))
  );
};
